import { ChevronDown } from "react-feather";
import {
  ADMIN,
  ADMIN_TOKEN,
  CART,
  CHECKOUT,
  CUSTOMER,
  CUSTOMER_TOKEN,
  SERVICE_CART,
  SUPER_ADMIN,
  SUPER_ADMIN_TOKEN,
} from "./constant";
import { useEffect, useRef, useState } from "react";

export const preventArrow = (e) => {
  if (e.which === 38 || e.which === 40) {
    e.preventDefault();
  }
};

export const preventClick = (e, func, ...param) => {
  if (e) e.preventDefault();
  if (func) func(param);
};

export const preventWheel = (e) => {
  e.target.addEventListener("wheel", function (e) {
    e.preventDefault();
  });
};

export const addOne = (value) => {
  value = Number(value);
  return ++value;
};

export const subtractOne = (value) => {
  value = Number(value);
  return value > 1 ? --value : value;
};

export const getTotal = (array, item) => {
  let total = 0;
  array.forEach((i) => {
    total = total + Number(item(i));
  });
  return total;
};

export const discountPrice = (price, discount, mode) => {
  price = Number(price);
  discount = Number(discount);
  if (mode === "percent") return price - (discount / 100) * price;
  else if (mode === "amount") return price - discount;
};

export const discountValue = (price, discount, mode) => {
  let discountValue = 0;
  if (discount && discount !== "") {
    price = Number(price);
    discount = Number(discount);
    if (mode === "percent") {
      discountValue = (discount / 100) * price;
      discountValue = Math.floor(discountValue);
    } else if (mode === "amount") return Number(discount);
  }
  return Number(discountValue);
};

export const groupBy = (list, keyGetter) => {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) map.set(key, [item]);
    else collection.push(item);
  });
  return map;
};

export const today = () => {
  const date = new Date();
  let today = [];
  today[2] = String(date.getDate()).padStart(2, "0");
  today[1] = String(date.getMonth() + 1).padStart(2, "0");
  today[0] = date.getFullYear();
  return today.join("-");
};

export const isEmptyObj = (variable) => {
  if (
    variable &&
    typeof variable === "object" &&
    Object.entries(variable).length === 0
  )
    return true;
  return false;
};

export const ratingCount = (ratingAndReview, rating) => {
  if (ratingAndReview && ratingAndReview.length > 0) {
    let star = 0;
    ratingAndReview
      .map((rr) => rr.rating)
      .forEach((element) => {
        if (Number(element) === rating) star = star + 1;
      });
    return star;
  }
  return 0;
};

export const ratingAvg1 = (reviews) => {
  if (!reviews || reviews.length === 0) return 0;
  const total = reviews.reduce((sum, r) => sum + (r.rating || 0), 0);
  return (total / reviews.length).toFixed(1); // average with 1 decimal
};

export const ratingAvg = (ratingAndReview, rating) => {
  if (ratingAndReview && ratingAndReview.length > 0) {
    let starCount = 0;
    let totalCount = 0;
    ratingAndReview
      .map((rr) => rr.rating)
      .forEach((element) => {
        if (Number(element) !== 0) {
          if (Number(element) === rating) starCount = starCount + 1;
          totalCount = totalCount + 1;
        }
      });
    return starCount > 0 ? ((starCount / totalCount) * 100).toFixed(1) : 0;
  }
  return 0;
};

export const totalRatingAvg = (ratingAndReview) => {
  if (ratingAndReview && ratingAndReview.length > 0) {
    let totalCount = 0;
    let totalRating = 0;
    ratingAndReview
      .map((rr) => rr.rating)
      .forEach((element) => {
        if (Number(element) !== 0) {
          totalCount = totalCount + 1;
          totalRating = totalRating + Number(element);
        }
      });
    return totalCount !== 0 && totalRating !== 0
      ? (totalRating / totalCount).toFixed(1)
      : 0;
  }
  return 0;
};

export const calculateItemTotal = (item) => {
  const price = parseFloat(item.price || 0);
  const qty = parseInt(item.qty || 1);
  const delivery = parseFloat(item.deliveryCharge || 0);
  const discountValue = parseFloat(item.discountValue || 0);
  const discountMode = item.discountMode;

  const base = price * qty;

  let discount = 0;
  if (discountMode === "percent") {
    discount = (base * discountValue) / 100;
  } else if (discountMode === "flat" || discountMode === "amount") {
    discount = discountValue;
  }

  return base - discount;
};

export const getCustomer = () => getFromLocalStorage(CUSTOMER, {});
export const getAdmin = () => getFromLocalStorage(ADMIN, {});
export const getSuperAdmin = () => getFromLocalStorage(SUPER_ADMIN, {});
export const getCheckout = () => getFromLocalStorage(CHECKOUT, {});

export const getCustomerToken = () => getFromLocalStorage(CUSTOMER_TOKEN, "");
export const getAdminToken = () => getFromLocalStorage(ADMIN_TOKEN, "");
export const getSuperAdminToken = () =>
  getFromLocalStorage(SUPER_ADMIN_TOKEN, "");

export const removeFromLocalStorage = (string) =>
  localStorage.removeItem(string);
export const setToLocalStorage = (key, value) =>
  localStorage.setItem(key, JSON.stringify(value));

export const getCart = () => getFromLocalStorage(CART, []);
export const getServiceCart = () => getFromLocalStorage(SERVICE_CART, []);

export const plusOrMinus = (string) =>
  String(string) === "plus" ? (
    <>&#43;</>
  ) : String(string) === "minus" ? (
    <>&#8722;</>
  ) : (
    ""
  );
export const mode = (mode, value) =>
  String(mode) === "percent" ? (
    <>{value}&#37;</>
  ) : String(mode) === "amount" ? (
    <>&#8377;{value}</>
  ) : (
    ""
  );
export const formateDate = (
  date,
  options = {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  },
) => new Intl.DateTimeFormat("en-US", options).format(new Date(date));
export const validateEmail = (email) =>
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    String(email).toLowerCase(),
  );
export const validatePhoneNumber = (number) =>
  /^[6-9]{1}[0-9]{9}$/.test(String(number));
export const validatePincode = (pin) => /^[1-9][0-9]{5}$/.test(String(pin));
export const isNum = (number) => /^[0-9]+$/.test(number);
export const setCart = (cart) =>
  localStorage.setItem("cart", JSON.stringify(cart));
export const emptyCart = () => {
  localStorage.removeItem(CART);
  localStorage.removeItem(CHECKOUT);
};

export const setServiceCart = (cart) =>
  localStorage.setItem(SERVICE_CART, JSON.stringify(cart));
export const emptyServiceCart = () => {
  localStorage.removeItem(SERVICE_CART);
  // localStorage.removeItem(CHECKOUT)
};

export const stateList = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];
export const now = () => new Date().getTime();
export const req = (string) => String(string) + " required";
export const tooLong = (string) => String(string) + " is too long";
export const getTimeStamp = (date) => new Date(String(date)).getTime();
export const getCurrentTimeStamp = () => new Date().getTime();
export const diffDays = (fromDate, toDate) => {
  fromDate = getTimeStamp(formateDate(fromDate));
  toDate = getTimeStamp(formateDate(toDate));
  return Number(Math.round((fromDate - toDate) / (1000 * 3600 * 24)));
};
export const diffDaysFromNow = (date) => {
  date = getTimeStamp(formateDate(date));
  let now = getCurrentTimeStamp();
  return Number(Math.round((now - date) / (1000 * 3600 * 24)));
};

const getFromLocalStorage = (string, dataType) => {
  const data = localStorage.getItem(string);
  return data ? JSON.parse(data) : dataType;
};

export const formatMonthDate = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleDateString("en-US", {
    month: "long", // "Sep"
    day: "2-digit", // "15"
  });
};
export const formateDateNumber = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return ""; // Invalid date

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12;

  return `${day}/${month}/${year}, ${formattedHours}:${minutes}:${seconds} ${ampm}`;
};

export const formatMonthDateYear = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("en-GB", { month: "long" });
  const year = date.getFullYear();
  return `${day} ${month}, ${year}`;
};
export const formatShortMonthDateYear = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getFullYear();
  return `${day} ${month}, ${year}`;
};
export const formatShortMonthDateYearWithTime = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return ""; // Handle invalid dates

  const day = date.getDate();
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getFullYear();

  // Format time to 12-hour format with AM/PM
  const timeOptions = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };
  const time = date.toLocaleTimeString("en-US", timeOptions);

  return `${day} ${month}, ${year} ${time}`;
};
export const formatNumber = (num) => {
  if (num === null || num === undefined || num === "") return "0.00";

  return Number(num).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

// Helper function to calculate price based on product type
export const calculateProductPrice = (item) => {
  const isB2C = !CUSTOMER || CUSTOMER.customerType === "individual";
  const basePrice = parseFloat(item.price) || 0;

  // Flow 1: qtyAndPrice has values - Find MINIMUM minQty and show its price
  if (item.qtyAndPrice && item.qtyAndPrice.length > 0) {
    // Find the entry with the minimum minQty value
    const minQtyEntry = item.qtyAndPrice.reduce((minEntry, currentEntry) => {
      return currentEntry.minQty < minEntry.minQty ? currentEntry : minEntry;
    }, item.qtyAndPrice[0]);

    if (minQtyEntry) {
      const displayPrice = isB2C
        ? parseFloat(minQtyEntry.setB2cPrice)
        : parseFloat(minQtyEntry.setB2bPrice);

      // Get quantity range from the minimum entry
      const minQty = minQtyEntry.minQty || 0;
      const maxQty = minQtyEntry.maxQty || 0;
      const basedOn = minQtyEntry.basedOn || "qty";

      // Calculate discount percentage
      let discountInfo = null;
      if (basePrice > 0 && basePrice > displayPrice) {
        const discountAmount = basePrice - displayPrice;
        const discountPercent = ((discountAmount / basePrice) * 100).toFixed(2);
        discountInfo = {
          value: discountPercent,
          mode: "%",
        };
      }

      return {
        displayPrice: isNaN(displayPrice)
          ? basePrice.toFixed(2)
          : displayPrice.toFixed(2),
        qtyRange: `${minQty} - ${maxQty} ${basedOn}`,
        originalPrice: basePrice.toFixed(2),
        discountInfo: discountInfo,
        priceType: "qtyAndPrice",
        basedOn: basedOn,
        minQtyValue: minQty,
      };
    }
  }

  // Flow 2: productVariant has values - Show min-max retail and selling prices
  if (item.productVariant && item.productVariant.length > 0) {
    const retailPrices = item.productVariant
      .map((variant) => {
        return parseFloat(variant.price) || 0;
      })
      .filter((price) => !isNaN(price) && price > 0);

    const sellingPrices = item.productVariant
      .map((variant) => {
        const variantPrice = parseFloat(variant.price) || 0;

        // Calculate discount for variant
        let finalPrice = variantPrice;
        const discMode = isB2C
          ? (variant.b2cDiscountMode || "").toLowerCase()
          : (variant.b2bDiscountMode || "").toLowerCase();
        const discValue = isB2C
          ? parseFloat(variant.b2cDiscountValue) || 0
          : parseFloat(variant.b2bDiscountValue) || 0;

        if (discMode === "percent") {
          finalPrice = variantPrice - (variantPrice * discValue) / 100;
        } else if (discMode === "amount") {
          finalPrice = variantPrice - discValue;
        }

        return Math.max(0, finalPrice);
      })
      .filter((price) => !isNaN(price) && price > 0);

    if (retailPrices.length > 0 && sellingPrices.length > 0) {
      const minRetail = Math.min(...retailPrices);
      const maxRetail = Math.max(...retailPrices);
      const minSelling = Math.min(...sellingPrices);
      const maxSelling = Math.max(...sellingPrices);

      // Create retail price display string
      let retailPriceDisplay = "";
      if (retailPrices.length > 1) {
        retailPriceDisplay = `₹ ${minRetail.toFixed(2)} - ${maxRetail.toFixed(2)}`;
      } else {
        retailPriceDisplay = `₹ ${minRetail.toFixed(2)}`;
      }

      // Create selling price display string
      let sellingPriceDisplay = "";
      if (sellingPrices.length > 1) {
        sellingPriceDisplay = `₹ ${minSelling.toFixed(2)} - ${maxSelling.toFixed(2)}`;
      } else {
        sellingPriceDisplay = `₹ ${minSelling.toFixed(2)}`;
      }

      return {
        retailPriceDisplay: retailPriceDisplay,
        sellingPriceDisplay: sellingPriceDisplay,
        priceType: "productVariant",
      };
    }
  }

  // Flow 3: Both arrays are empty - use current logic
  const b2bMode = (item.b2bDiscountMode || "").toLowerCase();
  const b2cMode = (item.b2cDiscountMode || "").toLowerCase();

  let b2bDiscountUnitPrice = basePrice;
  if (b2bMode === "percent") {
    const disc = parseFloat(item.b2bDiscountValue) || 0;
    b2bDiscountUnitPrice = basePrice - (basePrice * disc) / 100;
  } else if (b2bMode === "amount") {
    const disc = parseFloat(item.b2bDiscountValue) || 0;
    b2bDiscountUnitPrice = basePrice - disc;
  }

  let b2cDiscountUnitPrice = basePrice;
  if (b2cMode === "percent") {
    const disc = parseFloat(item.b2cDiscountValue) || 0;
    b2cDiscountUnitPrice = basePrice - (basePrice * disc) / 100;
  } else if (b2cMode === "amount") {
    const disc = parseFloat(item.b2cDiscountValue) || 0;
    b2cDiscountUnitPrice = basePrice - disc;
  }

  const finalPrice = isB2C ? b2cDiscountUnitPrice : b2bDiscountUnitPrice;
  const displayPrice = Math.max(0, Math.round(finalPrice)).toFixed(2);

  // Get discount info for display
  const custDiscVal = isB2C ? item.b2cDiscountValue : item.b2bDiscountValue;
  const custDiscMode = isB2C
    ? b2cMode === "percent"
      ? "%"
      : "₹"
    : b2bMode === "percent"
      ? "%"
      : "₹";

  return {
    displayPrice,
    priceRange: null,
    originalPrice: basePrice.toFixed(2),
    discountInfo:
      parseFloat(custDiscVal) > 0
        ? { value: custDiscVal, mode: custDiscMode }
        : null,
    priceType: "basePrice",
  };
};

// helper function for TransactionId
export const formatTransactionId = (order, payment) => {
  if (!order?.createTimestamp || !order?.id) return "TRN--";

  // Year YY
  const year = new Date(order.createTimestamp).getFullYear();
  const yy = String(year).slice(-2);

  // Order Id padded
  const paddedOrderId = String(order.id).padStart(4, "0");

  // Payment transaction ID padded
  const paddedTrnId = String(payment.id).padStart(4, "0");

  return `TRN${yy}/INV${yy}-${paddedOrderId}-${paddedTrnId}`;
};

// helper function for InvoiceId
export const formatInvoiceId = (order) => {
  if (!order?.createTimestamp || !order?.id) return "INV--";

  // Extract last 2 digits of year
  const year = new Date(order.createTimestamp).getFullYear();
  const yy = String(year).slice(-2); // e.g., 2025 → "25"

  // Zero-pad order.id to 4 digits
  const paddedId = String(order.id).padStart(4, "0"); // e.g., 7 → "0007"

  return `INV${yy}-${paddedId}`;
};

//helper functiom for OrderID
export const formatOrderId = (order) => {
  if (!order?.createTimestamp || !order?.id) return "ORD--";

  // Extract last 2 digits of year
  const year = new Date(order.createTimestamp).getFullYear();
  const yy = String(year).slice(-2); // e.g., 2025 → "25"

  // Zero-pad order.id to 4 digits
  const paddedId = String(order.id).padStart(4, "0"); // e.g., 7 → "0007"

  return `ORD${yy}-${paddedId}`;
};

// helper function for customerId
export const formatCustomerId = (customer) => {
  if (!customer?.createTimestamp || !customer?.id) return "CUS--";

  // Extract last 2 digits of year
  const year = new Date(customer.createTimestamp).getFullYear();
  const yy = String(year).slice(-2); // e.g., 2025 → "25"

  // Zero-pad order.id to 4 digits
  const paddedId = String(customer.id).padStart(4, "0"); // e.g., 7 → "0007"

  return `CUS${yy}-${paddedId}`;
};

//filter payment option sales modules
export const PAYMENT_OPTIONS = [
  { value: "paid", label: "Paid" },
  { value: "pending", label: "Unpaid" },
  { value: "partially paid", label: "Partially Paid" },
];

//filter status option for sales modules
export const STATUS_OPTIONS = [
  { value: "ordered", label: "Recieved" },
  { value: "confirmed", label: "Confirmed" },
  { value: "packed", label: "Packed" },
  { value: "shipped", label: "Shipped" },
  { value: "delivered", label: "Delivered" },
  { value: "return", label: "Return" },
  { value: "cancelled", label: "Cancelled" },
];
// filter status approval option in invoice
export const APPROVAL_OPTIONS = [
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
];
// custom color dropdown for sales module
export const CustomColoredDropdown = ({
  value,
  onChange,
  options,
  type = "payment",
  disable = false,
  loading = false,
  disabledOptions = [],
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const getColors = (status) => {
    if (type === "approval") {
      switch (status) {
        case "approved":
          return {
            color: "#065F46",
            bg: "#D1FAE5",
            border: `1px solid #065F46`,
          };
        case "rejected":
          return {
            color: "#991B1B",
            bg: "#FEE2E2",
            border: `1px solid #991B1B`,
          };
        default:
          return { color: "#CF9500", bg: "#FFF3BA", border: "none" };
      }
    }
    if (type === "payment") {
      switch (status) {
        case "paid":
          return { color: "white", bg: "#26DD8E", border: `1px solid #26DD8E` };
        case "pending":
          return { color: "white", bg: "#F8556D", border: `1px solid #F8556D` };
        case "partially-paid":
          return {
            color: "white",
            bg: "#D19A04",
            border: `1px solid #D19A04`,
          };
        default:
          return { color: "black", bg: "#fff", border: `1px solid #ccc` };
      }
    } else {
      switch (status) {
        case "delivered":
          return { color: "#46A27B", bg: "#D5F5E7", border: "none" };
        case "shipped":
          return { color: "#CF9500", bg: "#FFF3BA", border: "none" };
        case "packed":
          return { color: "#AC29AC", bg: "#FFCEFF", border: "none" };
        case "ordered":
          return { color: "#66B2E2", bg: "#D9EBFF", border: "none" };
        case "cancelled":
          return { color: "#E54611", bg: "#FDDFD0", border: "none" };
        case "return":
          return { color: "#8977C3", bg: "#DDD5F5", border: "none" };
        case "confirmed":
          return { color: "#39AFA7", bg: "#BFEFEC", border: "none" };
        case "rejected":
          return { color: "#E54611", bg: "#FDDFD0", border: "none" };
        case "need-approval":
          return { color: "#E54611", bg: "#FDDFD0", border: "none" };
        default:
          return { color: "black", bg: "#f5f5f5", border: "none" };
      }
    }
  };
  const { color, bg, border } = getColors(value);

  const displayLabel =
    options.find((opt) => opt.value === value)?.label ||
    (value
      ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
      : value);

  const handleToggle = () => {
    if (!disable) {
      setIsOpen(!isOpen);
    }
  };
  const handleOptionClick = (val) => {
    if (!disable) {
      onChange?.(val);
      setIsOpen(false);
    }
  };
  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        fontSize: "14px",
      }}
    >
      {/* Main Button */}
      <div
        onClick={handleToggle}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "6px 12px",
          border: border,
          borderRadius: "6px",
          backgroundColor: bg,
          cursor: disable || loading ? "not-allowed" : "pointer",
          fontWeight: "500",
          color: color,
          minWidth: "120px",
          opacity: disable || loading ? 0.7 : 1,
          pointerEvents: disable || loading ? "none" : "auto",
        }}
      >
        {loading ? (
          <span>Updating....</span>
        ) : (
          <>
            <span>{displayLabel}</span>
            {!disable && (
              <ChevronDown size={14} style={{ color, marginLeft: "6px" }} />
            )}
          </>
        )}
      </div>
      {/* Dropdown Menu — only show if enabled and open */}
      {!disable && isOpen && (
        <>
          <ul
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              width: "100%",
              listStyle: "none",
              margin: 0,
              padding: 0,
              backgroundColor: "#fff",
              border: border === "none" ? "none" : border,
              borderRadius: "6px",
              zIndex: 1000,
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              maxHeight: "150px",
              overflowY: "auto",
            }}
          >
            {options.map((opt) => {
              const optColors = getColors(opt.value);
              // Check if this option should be disabled
              const isOptionDisabled = disabledOptions.includes(opt.value);
              return (
                <li
                  key={opt.value}
                  onClick={() => {
                    if (!isOptionDisabled) {
                      handleOptionClick(opt.value);
                    }
                  }}
                  style={{
                    padding: "8px 12px",
                    cursor: isOptionDisabled ? "not-allowed" : "pointer",
                    color: optColors.color,
                    backgroundColor: optColors.bg,
                    fontWeight: "500",
                    border: "none",
                    opacity: isOptionDisabled ? 0.5 : 1,
                    pointerEvents: isOptionDisabled ? "none" : "auto",
                  }}
                  onMouseEnter={(e) => {
                    if (!isOptionDisabled) {
                      e.target.style.backgroundColor = "#f0f0f0";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isOptionDisabled) {
                      e.target.style.backgroundColor = optColors.bg;
                    }
                  }}
                >
                  {opt.label}
                </li>
              );
            })}
          </ul>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 999,
            }}
            onClick={() => setIsOpen(false)}
          />
        </>
      )}
    </div>
  );
};

//custom dropdown for download options in sales module
export const CustomDropdown = ({ handleDownloadCSV }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Options");
  const [isHovered, setIsHovered] = useState(false);

  const options = [
    { label: "Export", value: "export" },
    { label: "Export All", value: "export-all" },
  ];
  const handleSelect = (opt) => {
    setSelected(opt.label);
    setIsOpen(false);

    if (opt.value === "export") {
      // ✅ Export = current page only (but selected overrides)
      handleDownloadCSV("current");
    } else if (opt.value === "exportAll") {
      // ✅ Export All = entire dataset (but selected overrides)
      handleDownloadCSV("all");
    }

    setSelected("Options");
  };
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen]);
  return (
    <div
      className="custom-select"
      style={{ position: "relative", display: "inline-block" }}
      ref={dropdownRef}
    >
      <div
        className="select-header"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          backgroundColor: isHovered ? "#EDF8FA" : "#fff",
          color: "rgba(129, 134, 134, 1)",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          cursor: "pointer",
          width: "140px",
          height: "40px",
          textAlign: "left",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 500,
          transition: "background-color 0.2s ease",
        }}
      >
        <span>{selected}</span>
        <ChevronDown />
      </div>
      {isOpen && (
        <ul
          className="select-options"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            backgroundColor: "white",
            border: "none",
            borderRadius: "4px",
            zIndex: 1000,
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            fontWeight: 500,
          }}
        >
          {options.map((opt) => (
            <li
              key={opt.value}
              onClick={() => handleSelect(opt)}
              className="select-option"
              style={{
                padding: "8px 12px",
                color: "rgba(129, 134, 134, 1)",
                backgroundColor: "white",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export const FilterPanel = ({
  filterValues,
  onFilterChange,
  onApply,
  onClear,
  brands = [],
  categories = [],
  products = [],
  filterConfig = {
    showCustomerType: true,
    showTimePeriod: true,
    showPaymentType: true,
    showPaymentStatus: true,
    showStatus: true,
    showCategory: true,
    showBrand: true,
    showProduct: true,
    showDate: false,
  },
  filteredBrands,
  filteredProducts,
}) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        width: "500px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        zIndex: 1000,
        padding: "16px",
        maxHeight: "500px",
        overflowY: "auto",
        marginTop: "10px",
      }}
    >
      <div className="row g-3">
        {/* Customer Type Filter */}
        {filterConfig.showCustomerType && (
          <div className="col-md-6">
            <select
              className="form-select filter-input"
              value={filterValues.customerType || ""}
              onChange={(e) => onFilterChange("customerType", e.target.value)}
            >
              <option value="">Customer Type</option>
              <option value="dealer">Dealer</option>
              <option value="sub-dealer">Sub Dealer</option>
              <option value="individual">Individual</option>
              <option value="engineer">Engineer</option>
              <option value="builder">Builder</option>
              <option value="architect">Architect</option>
              <option value="contractor">Contractor</option>
            </select>
          </div>
        )}

        {/* Time Period Filter */}
        {filterConfig.showTimePeriod && (
          <div className="col-md-6">
            <select
              className="form-select filter-input"
              value={filterValues.timePeriod || ""}
              onChange={(e) => onFilterChange("timePeriod", e.target.value)}
            >
              <option value="">Time Period</option>
              <option value="all">All Time</option>
              <option value="today">Today</option>
              <option value="yesterday">Yesterday</option>
              <option value="thisMonth">This Month</option>
              <option value="last3Months">Last 3 Months</option>
              <option value="thisYear">This Year</option>
              <option value="period">Custom Period</option>
            </select>
          </div>
        )}

        {/* Custom Date Range (only when "period" selected) */}
        {filterConfig.showTimePeriod &&
          filterValues.timePeriod === "period" && (
            <>
              <div className="col-md-6">
                <input
                  type={filterValues.fromDate ? "date" : "text"}
                  className="form-control filter-input"
                  placeholder="From Date"
                  value={filterValues.fromDate || ""}
                  onFocus={(e) => (e.target.type = "date")}
                  onBlur={(e) => {
                    if (!filterValues.fromDate) e.target.type = "text";
                  }}
                  onChange={(e) => onFilterChange("fromDate", e.target.value)}
                />
              </div>
              <div className="col-md-6">
                <input
                  type={filterValues.toDate ? "date" : "text"}
                  className="form-control filter-input"
                  placeholder="To Date"
                  value={filterValues.toDate || ""}
                  onFocus={(e) => (e.target.type = "date")}
                  onBlur={(e) => {
                    if (!filterValues.toDate) e.target.type = "text";
                  }}
                  onChange={(e) => onFilterChange("toDate", e.target.value)}
                />
              </div>
            </>
          )}

        {/* Payment Type Filter */}
        {filterConfig.showPaymentType && (
          <div className="col-md-6">
            <select
              className="form-select filter-input"
              value={filterValues.paymentType || ""}
              onChange={(e) => onFilterChange("paymentType", e.target.value)}
            >
              <option value="">Payment Type</option>
              <option value="cod">Cash On Delivery</option>
              <option value="credit">Credit</option>
              <option value="cash">Cash</option>
              <option value="credit-card">Credit Card</option>
              <option value="cheque">Cheque</option>
              <option value="debit-card">Debit Card</option>
              <option value="net-banking">Net Banking</option>
              <option value="upi">UPI</option>
              <option value="neft">NEFT</option>
              <option value="rtgs">RTGS</option>
            </select>
          </div>
        )}

        {/* Payment Status Filter */}
        {filterConfig.showPaymentStatus && (
          <div className="col-md-6">
            <select
              className="form-select filter-input"
              value={filterValues.paymentStatus || ""}
              onChange={(e) => onFilterChange("paymentStatus", e.target.value)}
            >
              <option value="">Payment Status</option>
              <option value="paid">Paid</option>
              <option value="pending">Pending</option>
              <option value="partially-paid">Partially Paid</option>
            </select>
          </div>
        )}

        {/* Order Status Filter */}
        {filterConfig.showStatus && (
          <div className="col-md-6">
            <select
              className="form-select filter-input"
              value={filterValues.status || ""}
              onChange={(e) => onFilterChange("status", e.target.value)}
            >
              <option value="">Order Status</option>
              <option value="ordered">Ordered</option>
              <option value="confirmed">Confirmed</option>
              <option value="packed">Packed</option>
              <option value="shipped">Shipped</option>
              <option value="delivered">Delivered</option>
              <option value="return">Return</option>
              <option value="cancelled">Cancelled</option>
            </select>
          </div>
        )}

        {/* Category Filter (only if config allows AND categories exist) */}
        {filterConfig.showCategory && categories.length > 0 && (
          <div className="col-md-6">
            <select
              className="form-select filter-input"
              value={filterValues.categoryId || ""}
              onChange={(e) => onFilterChange("categoryId", e.target.value)}
            >
              <option value="">Category</option>
              {categories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.name}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Brand Filter (only if config allows AND brands exist) */}
        {filterConfig.showBrand && brands.length > 0 && (
          <div className="col-md-6">
            <select
              className="form-select filter-input"
              value={filterValues.brandId}
              onChange={(e) => onFilterChange("brandId", e.target.value)}
              disabled={!filterValues.categoryId && filteredBrands.length === 0}
            >
              <option value="">Brand</option>
              {filteredBrands.map((brand) => (
                <option key={brand.id} value={brand.id}>
                  {brand.name}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Product Filter (only if config allows AND products exist) */}
        {filterConfig.showProduct && products.length > 0 && (
          <div className="col-md-6">
            <select
              className="form-select filter-input"
              value={filterValues.productId}
              onChange={(e) => onFilterChange("productId", e.target.value)}
            >
              <option value="">Product</option>
              {filteredProducts.map((product) => (
                <option key={product.id} value={product.id}>
                  {product.name}{" "}
                  {product.brandName ? `(${product.brandName})` : ""}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      <div className="d-flex gap-14 mt-24">
        <button
          onClick={onApply}
          style={{
            color: "#fff",
            backgroundColor: "#2b95d3",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
          }}
        >
          Apply Filters
        </button>
        <button
          onClick={onClear}
          style={{
            color: "#2692d2",
            backgroundColor: "#d9ebff",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
            gap: "6px",
          }}
        >
          Clear All
        </button>
      </div>
    </div>
  );
};
